export default "__VITE_PUBLIC_ASSET__fcec30c4__"